/**
 * Vuex "groupchannel" module (registered as `groupchannel` in the root store).
 *
 * Manages the currently viewed group channel's details, the list of group
 * channels, and a user's following list: state (store.js), actions
 * (operations.js), getters (selectors.js), and mutations (updates.js).
 */
import actions from './operations';
import getters from './selectors';
import mutations from './updates';
import state from './store';

export default {
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
